import i18n from '@components/i18n/i18n';
import LanguageMenu from '@components/i18n/LanguageMenu';
import { Col, Layout, Row } from 'antd';
import React from 'react';

const LoginMobileHeader: React.FunctionComponent<{}> = () => {

  function onLanguageChange(domEvent, key) {
    domEvent.preventDefault();
    if (key !== i18n.language)
      i18n.changeLanguage(key);
  }

  return (
    <Layout.Header style={{ background: '#004750' }}>
      <Row gutter={24}>
        <Col span={16}>
          <img src='https://static.qupital.com/funder/company_logo.svg' />
        </Col>
        <Col span={8} style={{ textAlign: 'right', paddingRight: 0 }}>
          <LanguageMenu onLanguageChange={onLanguageChange} />
        </Col>
      </Row>

    </Layout.Header>
  )
}

export { LoginMobileHeader };
